import { render } from "./selectLessonFile.vue?vue&type=template&id=5223fcf8"
import script from "./selectLessonFile.vue?vue&type=script&lang=js"
export * from "./selectLessonFile.vue?vue&type=script&lang=js"

import "./selectLessonFile.vue?vue&type=style&index=0&id=5223fcf8&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__